import { useQuery } from "react-query";

import { makeRequest } from "../../util";
import { GetCatalogedTrackersResponse } from "../types";

export default function useFetchCatalogedTrackers() {
  return useQuery("catalogedTrackers", async () => {
    const res = await makeRequest<GetCatalogedTrackersResponse>(
      "get_cataloged_trackers"
    );

    return res.data;
  });
}
